module.exports = __webpack_public_path__ + "img/news3-3.1aab0fdb.png";